import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import Stats from 'three/examples/jsm/libs/stats.module.js'

// Setup

const stats = new Stats()
stats.showPanel(0)
document.body.appendChild(stats.dom)
const sizes =  { width: window.innerWidth, height: window.innerHeight }
const canvas =  document.querySelector('canvas.webgl')
const scene =  new THREE.Scene()
const camera = new THREE.PerspectiveCamera(15, sizes.width/sizes.height, 0.1, 2000)
camera.position.set(1.5,0.25,1.5)
scene.add(camera)
const controls = new OrbitControls(camera, canvas)
controls.target = new THREE.Vector3(0.0,0.1,0.0)
controls.enableDamping = true
const renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true })
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.setClearColor(0x2a3b5c)
renderer.outputEncoding = THREE.sRGBEncoding
renderer.physicallyCorrectLights = true
renderer.toneMapping = THREE.ACESFilmicToneMapping
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap

// Window Resize Event Listener

window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight
    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()
    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

// Loaders

const textureLoader = new THREE.TextureLoader()
const cubeTextureLoader = new THREE.CubeTextureLoader()
const gltfLoader = new GLTFLoader()


// Cube Textures

const environmentMap = cubeTextureLoader.load([
    './assets/environmentMaps/px.jpg',
    './assets/environmentMaps/nx.jpg',
    './assets/environmentMaps/py.jpg',
    './assets/environmentMaps/ny.jpg',
    './assets/environmentMaps/pz.jpg',
    './assets/environmentMaps/nz.jpg'
])

environmentMap.encoding = THREE.sRGBEncoding
scene.environment = environmentMap

// Pencil Textures

const colorMap = textureLoader.load('./assets/textures/color.jpg')
colorMap.encoding = THREE.sRGBEncoding
colorMap.flipY = false
const metalnessMap = textureLoader.load('./assets/textures/metalness.png')
metalnessMap.flipY = false
const roughnessMap = textureLoader.load('./assets/textures/roughness.jpg')
roughnessMap.flipY = false

// Pencil Material

const pencilMaterial = new THREE.MeshStandardMaterial({
    map:colorMap,
    metalnessMap: metalnessMap,
    roughnessMap: roughnessMap,
    envMap: environmentMap,
    envMapIntensity: 20.0,
})

// Groundplane

const groundPlaneGeo = new THREE.CircleGeometry(.3,90)
const groundPlaneMaterial = new THREE.MeshStandardMaterial({color:0xdddddd, side: THREE.DoubleSide, envMapIntensity: 10.0})
const groundPlane = new THREE.Mesh(groundPlaneGeo, groundPlaneMaterial)
groundPlane.position.set(0.0,-.001,0.0)
groundPlane.rotation.x = Math.PI / 2
groundPlane.receiveShadow = true
scene.add(groundPlane)

// Lights

const directionalLightPivot = new THREE.Group()
const directionalLight = new THREE.DirectionalLight(0xeeeeff, 1.0)
directionalLight.position.set(2.52,3.21,4)
directionalLight.castShadow = true
directionalLight.shadow.normalBias = 0.0025
directionalLight.shadow.mapSize.width = 512
directionalLight.shadow.mapSize.height = 512
directionalLight.shadow.camera.near = 5.35
directionalLight.shadow.camera.far = 6.0
directionalLight.shadow.camera.top = .3
directionalLight.shadow.camera.right = .3
directionalLight.shadow.camera.bottom = -.2
directionalLight.shadow.camera.left = -.3
directionalLight.shadow.blurSamples

const ambientLight = new THREE.AmbientLight(0xeeeeff, 0.5)

scene.add(directionalLight, ambientLight)

// Load GLTF

let pencilGroup = new THREE.Group()

let pencil = null
gltfLoader.load(
    './assets/pencil.glb',
    (gltf) => {
        gltf.scene.traverse((child) =>
        {
            if (child.type === 'Mesh') {
                child.material = pencilMaterial
                child.castShadow = true
                child.receiveShadow = true
                child.material.side = THREE.DoubleSide

            }
        })

        pencil = gltf.scene
        pencilGroup.rotation.z = -Math.PI/6
        pencilGroup.add(pencil)
        scene.add(pencilGroup)
    }
)

// Animate

const clock = new THREE.Clock()

const animate = () => {
    stats.begin()

    const elapsedTime = clock.getElapsedTime()
    if ( pencil )
    {
        pencil.rotation.y = elapsedTime
        pencilGroup.position.set(pencilGroup.position.x, Math.sin(elapsedTime * 2)/32 + 1/32, pencilGroup.position.z)
    }

    controls.update()

    renderer.render(scene, camera)

    stats.end()

    window.requestAnimationFrame(animate)
}

animate()